import axios from 'axios';
import { useAuthStore } from '@/stores/authstore'; 
import { showSessionExpiredModalComp } from '@/stores/modalstore'; // Importamos el store del modal

const travelAPI = axios.create({
  baseURL: process.env.VUE_APP_TRAVELAPIURL 
});

travelAPI.interceptors.request.use(config => {
  // Instancia el store de Pinia para poder usarlo
  const authStore = useAuthStore();
  const token = authStore.token;

  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }

  return config;
});

// Interceptor de respuesta para manejar errores globales (como token expirado)
travelAPI.interceptors.response.use(
  response => response,
  error => {
    const authStore = useAuthStore();
    
    // Si el error es 401 (No autorizado), asumimos que el token venció o es inválido
    if (error.response && error.response.status === 401) {
      console.warn("Sesión expirada o token inválido (401). Cerrando sesión...");

      // Mostramos el modal y le pasamos la lógica de redirección como un callback.
      showSessionExpiredModalComp(() => {
        // 1. Limpiamos el estado de autenticación
        const logoutUrl = authStore.logout();
        
        // 2. Redirigimos al usuario a la URL de logout si existe
        if (logoutUrl) {
          window.location.href = logoutUrl;
        } else {
          // Si no hay URL, recargamos la página para reiniciar el estado de la app (a invitado)
          window.location.reload();
        }
      });
    }
    return Promise.reject(error);
  }
);

export default travelAPI;